import { createContext, useState } from 'react';
import api from 'services/api';

export const LocalEstoqueContext = createContext();

export const LocalEstoqueProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [localEstoque, setLocalEstoque] = useState({
    data: [],
    colunas: [],
    filter: {},
    page: 0,
    size: 10,
  });

  const getLocalEstoque = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: localEstoque?.filter,
        page: localEstoque?.page,
        size: localEstoque?.size,
        order: localEstoque?.order,
        ...payload,
      });
      setLocalEstoque((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <LocalEstoqueContext.Provider
      value={{
        getLoading,
        localEstoque,
        getLocalEstoque,
      }}
    >
      {children}
    </LocalEstoqueContext.Provider>
  );
};
